import React, { useEffect, useState } from 'react';
import type { Departure } from '../types/api';
import { fetchDepartures } from '../utils/api';
import { delayColor } from '../utils/format';

interface DepartureBoardProps {
  stopId: string | null;
  stopName?: string;
  onClose: () => void;
}

export default function DepartureBoard({ stopId, stopName, onClose }: DepartureBoardProps) {
  const [departures, setDepartures] = useState<Departure[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!stopId) return;
    let mounted = true;
    const load = async () => {
      setLoading(true);
      try {
        const res = await fetchDepartures(stopId);
        if (mounted) setDepartures(res.departures || []);
      } catch {
        if (mounted) setDepartures([]);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    const interval = setInterval(load, 60000);
    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, [stopId]);

  if (!stopId) return null;

  return (
    <div className="departure-board">
      <div className="board-header">
        <h3>{stopName || stopId}</h3>
        <button onClick={onClose}>Close</button>
      </div>
      {loading && <div>Loading...</div>}
      {!loading && departures.length === 0 && <div>No departures found</div>}
      <table>
        <thead>
          <tr>
            <th>Route</th>
            <th>Headsign</th>
            <th>Delay</th>
          </tr>
        </thead>
        <tbody>
          {departures.map((d, i) => (
            <tr key={i}>
              <td>{d.trip.route.shortName}</td>
              <td>{d.headsign}</td>
              <td style={{ color: delayColor(d.departureDelay) }}>
                {d.departureDelay === 0 ? 'On time' : `${d.departureDelay > 0 ? '+' : ''}${Math.round(d.departureDelay / 60)}m`}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
